var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormLeftBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 117,
    viewBox: "0 0 70 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.733 106.054C11.3662 90.1461 16.8194 59.8163 59.3916 58.3963C59.8834 74.3042 51.3078 104.645 11.733 106.054Z",
    fill: "#00B7F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3932 59.098C43.485 59.4648 13.1552 54.0117 11.7351 11.4395C27.6431 10.9476 57.9837 19.5233 59.3932 59.098Z",
    fill: "#00B7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormLeftBottom);
export default __webpack_public_path__ + "static/media/formLeftBottom.5451f0d06c10610cb9cf41d54d5478b4.svg";
export { ForwardRef as ReactComponent };